export default __webpack_public_path__ + "static/media/camera-house-mobile-two.35b625b6.png";